import { useState, useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import MobileAppSplashScreen from 'shared-module/download-app/MobileAppSplashScreen'
import SpypointPrivateRoute from 'spypoint/src/private-route/SpypointPrivateRoute'
import CameraSettingsPage from 'camera-module/camera/ui/camera-settings-page/CameraSettingsPage'
import CameraPlan from 'checkout-module/checkout/ui/transmission-plans-page/Plan'
import CameraDashboard from 'photo-module/photos/ui/photos-gallery/Dashboard'
import PhotoPreview from 'photo-module/photo/ui/photo-viewer/PhotoPreview'
import PhotoViewer from 'photo-module/photo/ui/photo-viewer/PhotoViewer'
import RedeemPromoCodesPage from 'user-module/promo-code/ui/redeem-promo-codes/RedeemPromoCodesPage'
import SpypointAppBar from 'spypoint/src/shared-module/navigation/app-bar/SpypointAppBar'
import Head from 'shared-module/new-components/head/Head'
import { useTranslation } from 'react-i18next'
import MembershipPage from 'spypoint/src/user-module/club-membership/ui/MembershipPage'
import Order from 'checkout-module/order/Order'
import CartPage from 'spypoint/src/checkout-module/order/ui/cart-page/CartPage'
import CheckoutPage from 'spypoint/src/checkout-module/order/ui/checkout-page/CheckoutPage'
import CameraListPanel from 'cameras-module/ui/cameras-page/CameraListPanel'
import SharedCameraListPanel from 'cameras-module/ui/cameras-page/SharedCameraListPanel'
import SpypointCameraStatusPage from 'cameras-module/ui/camera-status-page/SpypointCameraStatusPage'
import SpypointAccountPage from 'spypoint/src/user-module/account/SpypointAccountPage'
import SpypointFiltersBar from './photos-module/filters/ui/SpypointFiltersBar'
import ProfilePanel from 'spypoint/src/user-module/account/profile/ProfilePanel'
import PlansAndSubscriptionPanel from 'spypoint/src/user-module/account/plan-and-subscription/PlansAndSubscriptionPanel'
import PaymentPanel from 'spypoint/src/user-module/account/payment/PaymentPanel'
import ManagementPanel from 'user-module/account/management/ManagementPanel'
import ExternalPageContainer from 'user-module/user/ui/ExternalPageContainer'
import LoginPage from 'user-module/user/ui/login/LoginPage'
import RegisterPage from 'user-module/user/ui/register/RegisterPage'
import ResetPasswordPage from 'user-module/user/ui/reset-password/ResetPasswordPage'
import ChangePasswordPage from 'user-module/user/ui/change-password/ChangePasswordPage'
import SpypointPublicPageLayout from 'spypoint/src/shared-module/ui/public-page/SpypointPublicPageLayout'
import INSTRUCTION_TYPES from 'user-module/user/core/instructionTypes'
import PublicRoute from 'shared-module/public-route/PublicRoute'
import SpypointAddCameraPage from './cameras-module/ui/cameras-page/SpypointAddCameraPage'
import CameraActivationPanel from 'camera-module/new-activation/ui/CameraActivationPanel'
import appConfig from 'shared-module/config/appConfig'
import switches from 'shared-module/config/switches'
import ActivationConfirmationPanel from 'camera-module/new-activation/ui/ActivationConfirmationPanel'
import CameraSharingPage from 'camera-module/camera/ui/camera-sharing-page/CameraSharingPage'
import CamerasPanel from 'camera-module/camera/ui/camera-sharing-page/CamerasPanel'
import GuestPanel from 'camera-module/camera/ui/camera-sharing-page/guest-panel/GuestPanel'
import SharedCameraPage from 'spypoint/src/shared-camera-module/SharedCameraPage'
import { useLDFlags } from 'spypoint/src/launchDarkly-module/launchDarklyFlagsContext.js'
import MarketingNewsLetterJournayB from 'spypoint/src/cameras-module/MarketingNewsLetterJournayB'
import MarketingNewsletterJourneyBLastDialog from 'spypoint/src/cameras-module/MarketingNewsletterJourneyBLastDialog'
import MarketingNewsLetterSubscribe from 'spypoint/src/cameras-module/MarketingNewsLetterSubscribe'

const Routes = () => {
  const [isOpenNewsLetterConfirmationDialog, setIsOpenNewsLetterConfirmationDialog] = useState(false)
  const [isOpenNewsLetterDialog, setIsOpenNewsLetterDialog] = useState(true)
  const [isOpenNewsLetterBDialog, setIsOpenNewsLetterBDialog] = useState(true)
  const [open, setOpen] = useState(false)
  const [openLastPopin, setOpenLastPopin] = useState(false)
  const [openB, setOpenB] = useState(false)
  const [openMarketingConsentDialog, setOpenMarketingConsentDialog] = useState(false)
  const [openLastPopinB, setOpenLastPopinB] = useState(false)
  const showPopup2 = () => localStorage.getItem('popup2') ? JSON.parse(localStorage.getItem('popup2')) : false
  const showPopup4 = () => localStorage.getItem('popup4') ? JSON.parse(localStorage.getItem('popup4')) : false
  const showPopup5 = () => localStorage.getItem('popup5') ? JSON.parse(localStorage.getItem('popup5')) : false
  const firstTime = () => localStorage.getItem('firstTime') ? JSON.parse(localStorage.getItem('firstTime')) : false
  const secondTime = () => localStorage.getItem('secondTime') ? JSON.parse(localStorage.getItem('secondTime')) : false
  const optInLastB = () => localStorage.getItem('optInLastB') ? JSON.parse(localStorage.getItem('optInLastB')) : false
  const optInSubscribe = () => localStorage.getItem('optInSubscribe') ? JSON.parse(localStorage.getItem('optInSubscribe')) : false
  const optInB = () => localStorage.getItem('optInB') ? JSON.parse(localStorage.getItem('optInB')) : false
  let showPopup3
  useEffect(() => {
    showPopup5() && !optInSubscribe() && setOpenMarketingConsentDialog(true)
  }, [])
  useEffect(() => {
    showPopup2() && !optInB() && handleOpenDialogB()
  }, [])
  useEffect(() => {
    showPopup4() && !optInLastB() && handleOpenLastDialogB()
  }, [])
  let timerB
  const handleOpenDialogB = () => {
    const waitTime = 1000 * 60 * 60 * 24
    let executionTime
    const initialTime = localStorage.getItem('initialTime')
    if (initialTime === null) {
      localStorage.setItem('initialTime', (new Date()).getTime())
      executionTime = waitTime
    } else {
      executionTime = parseInt(initialTime, 10) + waitTime - (new Date()).getTime()
      if (executionTime < 0) executionTime = 0
    }
    timerB = setTimeout(() => {
      if (!firstTime()) {
        setOpenB(true)
        localStorage.removeItem('initialTime')
        localStorage.setItem('firstTime', true)
      }
    }, executionTime)
    if (!optInB() && firstTime()) setOpenB(true)
  }
  const handleOpenLastDialogB = () => {
    const waitTime = 1000 * 60 * 60 * 24
    let executionTime
    const initialTimeLast = localStorage.getItem('initialTimeLast')
    if (initialTimeLast === null) {
      localStorage.setItem('initialTimeLast', (new Date()).getTime())
      executionTime = waitTime
    } else {
      executionTime = parseInt(initialTimeLast, 10) + waitTime - (new Date()).getTime()
      if (executionTime < 0) executionTime = 0
    }
    timerB = setTimeout(() => {
      if (!secondTime()) {
        setOpenLastPopinB(true)
        localStorage.removeItem('initialTimeLast')
        localStorage.setItem('secondTime', true)
      }
    }, executionTime)
    if (!optInLastB() && secondTime()) setOpenLastPopinB(true)
  }
  let timer
  let time
  const handleOpen = () => {
    timer = setTimeout(() => {
      setOpen(true)
    }, 1000 * 60 * 60 * 24)
  }
  const handleOpenLastPopin = () => {
    time = setTimeout(() => {
      setOpenLastPopin(true)
    }, 1000 * 60 * 60 * 24)
  }
  const clear = () => clearTimeout(timer)
  const clearLasttimer = () => clearTimeout(time)
  const clearTimerB = () => clearTimeout(timerB)
  return (
    <Switch>
      <PublicRoute
        exact
        path="/login"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={(
          <LoginPage
            clear={clear}
            setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog}
            setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog}
            clearLasttimer={clearLasttimer}
            clearTimerB={clearTimerB}
          />
        )}
        instructionTypes={INSTRUCTION_TYPES.LOGIN}
      />
      <PublicRoute
        exact
        path="/:lng/login/:instruction"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={(
          <LoginPage
            clear={clear}
            setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog}
            setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog}
            clearLasttimer={clearLasttimer}
            clearTimerB={clearTimerB}
          />
        )}
        instructionTypes={INSTRUCTION_TYPES.LOGIN}
      />
      <PublicRoute
        exact
        path="/register"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={<RegisterPage isComplexPassword={false} />}
        instructionTypes={INSTRUCTION_TYPES.REGISTER}
      />
      <PublicRoute
        exact
        path="/:lng/register/:instruction"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={<RegisterPage isComplexPassword={false} />}
        instructionTypes={INSTRUCTION_TYPES.REGISTER}
      />
      <PublicRoute
        exact
        path="/reset-password"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={<ResetPasswordPage />}
      />
      <PublicRoute
        exact
        path="/reset-password/:token"
        component={ExternalPageContainer}
        Layout={SpypointPublicPageLayout}
        Content={<ChangePasswordPage isComplexPassword={false} />}
      />
      <Route exact path="/download-app" component={MobileAppSplashScreen} />
      <SpypointPrivateRoute openMarketingConsentDialog={openMarketingConsentDialog} setOpenMarketingConsentDialog={setOpenMarketingConsentDialog} openLastPopin={openLastPopin} handleOpenLastPopin={handleOpenLastPopin} setOpenLastPopin={setOpenLastPopin} open={open} openB={openB} setOpen={setOpen} handleOpen={handleOpen} setOpenB={setOpenB} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog} setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} path="/" component={PrivateRoutes} handleOpenDialogB={handleOpenDialogB} handleOpenLastDialogB={handleOpenLastDialogB} showPopup3={showPopup3} openLastPopinB={openLastPopinB} setOpenLastPopinB={setOpenLastPopinB} />
    </Switch>
  )
}

const PrivateRoutes = ({ handleOpen, setIsOpenNewsLetterConfirmationDialog, isOpenNewsLetterConfirmationDialog, isOpenNewsLetterDialog, setIsOpenNewsLetterBDialog, isOpenNewsLetterBDialog, setIsOpenNewsLetterDialog, setOpen, open, openLastPopin, setOpenLastPopin, handleOpenLastPopin, openB, setOpenB, handleOpenDialogB, handleOpenLastDialogB, openLastPopinB, setOpenLastPopinB, setOpenMarketingConsentDialog, openMarketingConsentDialog }) => {
  const { flags } = useLDFlags()
  const { t } = useTranslation()
  const sharedCameraEnabled = appConfig.sharedCamera?.switch === switches.on
  const marketingConsentEnabled = flags && flags['marketing-consent']
  const eCommerceldEnabled = flags && flags['e-commerce']
  const referralProgramSunsetEnabled = flags && flags['referral-program-sunset']
  const isReferralProgramSunset = referralProgramSunsetEnabled?.isReferralProgramSunset

  return (
    <>
      <Head title={t('app:head.title')} />
      <SpypointAppBar />
      { marketingConsentEnabled && openLastPopinB && <MarketingNewsletterJourneyBLastDialog onClose={() => setOpenLastPopinB(false)} setOpenMarketingConsentDialog={setOpenMarketingConsentDialog} handleOpen={handleOpen} setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} setOpen={setOpen} handleOpenDialogB={handleOpenDialogB} handleOpenLastDialogB={handleOpenLastDialogB} /> }
      { marketingConsentEnabled && openB && <MarketingNewsLetterJournayB onClose={() => setOpenB(false)} handleOpenLastPopin={handleOpenLastPopin} handleOpen={handleOpen} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} setOpen={setOpen} setOpenB={setOpenB} handleOpenDialogB={handleOpenDialogB} handleOpenLastDialogB={handleOpenLastDialogB} /> }
      { marketingConsentEnabled && openMarketingConsentDialog && <MarketingNewsLetterSubscribe setOpenMarketingConsentDialog={setOpenMarketingConsentDialog} optInB onClose={() => setOpenMarketingConsentDialog(false)} handleOpenLastPopin={handleOpenLastPopin} handleOpen={handleOpen} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} setOpen={setOpen} setOpenB={setOpenB} handleOpenDialogB={handleOpenDialogB} handleOpenLastDialogB={handleOpenLastDialogB} /> }
      <Switch>
        <SpypointPrivateRoute exact path="/camera/plan" component={SharedCameraPage} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog} setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog} handleOpen={handleOpen} setOpenB={setOpenB} setOpen={setOpen} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} />
        <SpypointPrivateRoute exact path="/camera/:id/status" component={SpypointCameraStatusPage} />
        <SpypointPrivateRoute exact path="/camera/:id/settings" component={CameraSettingsPage} />
        <SpypointPrivateRoute exact path="/camera/:id/plan" component={CameraPlan} />
        <SpypointPrivateRoute exact path="/camera/:cameraId/photo/:photoId/preview" component={CameraDashboard} />
        <SpypointPrivateRoute exact path="/camera/:cameraId/photo/:photoId" component={CameraDashboard} />
        <SpypointPrivateRoute
          path="/camera/:id"
          component={CameraDashboard}
        />
        <SpypointPrivateRoute path="/account" component={SpypointAccountPage} />
        <SpypointPrivateRoute exact path="/account/profile" component={ProfilePanel} />
        <SpypointPrivateRoute exact path="/account/plans-and-subscriptions" component={PlansAndSubscriptionPanel} />
        <SpypointPrivateRoute exact path="/account/payment" component={PaymentPanel} />
        <SpypointPrivateRoute exact path="/account/management" component={ManagementPanel} />
        <SpypointPrivateRoute exact path="/membership" component={MembershipPage} />
        { !isReferralProgramSunset && !eCommerceldEnabled && <SpypointPrivateRoute exact path="/promo-codes" component={RedeemPromoCodesPage} /> }
        <SpypointPrivateRoute exact path="/order" component={Order} />
        <SpypointPrivateRoute exact path="/cart" component={CartPage} />
        <SpypointPrivateRoute path="/camera-sharing" component={CameraSharingPage} />
        <SpypointPrivateRoute exact path="/camera-sharing/guests" component={GuestPanel} />
        <SpypointPrivateRoute exact path="/camera-sharing/cameras" component={CamerasPanel} />
        <SpypointPrivateRoute exact path="/checkout" component={CheckoutPage} />

        { /* TODO: REMOVE FEATURE SWITCH ONCE READY FOR PRODUCTION */ }
        <SpypointPrivateRoute exact path="/add-camera" component={SpypointAddCameraPage} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog} setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog} handleOpen={handleOpen} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} setOpen={setOpen} setOpenB={setOpenB} handleOpenLastDialogB={handleOpenLastDialogB} handleOpenDialogB={handleOpenDialogB} />
        { /* TODO: REMOVE FEATURE SWITCH ONCE READY FOR PRODUCTION */ }
        <SpypointPrivateRoute path="/camera-activation" component={CameraActivationPanel} />

        { /* TODO: REMOVE FEATURE SWITCH ONCE READY FOR PRODUCTION */ }
        <SpypointPrivateRoute path="/confirm-activation/:id" component={ActivationConfirmationPanel} />
        <SpypointPrivateRoute path="/confirm-activation" component={ActivationConfirmationPanel} />
        { sharedCameraEnabled && <SpypointPrivateRoute path="/" component={SharedCameraPage} /> }
        { sharedCameraEnabled && <SpypointPrivateRoute exact path="/camera-list" setIsOpenNewsLetterBDialog={setIsOpenNewsLetterBDialog} setIsOpenNewsLetterDialog={setIsOpenNewsLetterDialog} isOpenNewsLetterBDialog={isOpenNewsLetterBDialog} isOpenNewsLetterDialog={isOpenNewsLetterDialog} handleOpen={handleOpen} isOpenNewsLetterConfirmationDialog={isOpenNewsLetterConfirmationDialog} setIsOpenNewsLetterConfirmationDialog={setIsOpenNewsLetterConfirmationDialog} setOpen={setOpen} setOpenB={setOpenB} component={CameraListPanel} handleOpenDialogB={handleOpenDialogB} handleOpenLastDialogB={handleOpenLastDialogB} /> }
        { sharedCameraEnabled && <SpypointPrivateRoute exact path="/shared-cameras" component={SharedCameraListPanel} /> }
      </Switch>
    </>
  )
}

export default Routes
